// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 22/2/2024
 */

 .ForgotPassword_container__7KQGp {
    display: flex;
    justify-content: center;
}

.ForgotPassword_paper__xHjci {
    padding: 2rem;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 10px 0px rgba(89, 124, 215, 0.25);
    background: linear-gradient(91deg, rgba(222, 248, 248, 0.32) 23.22%, rgba(222, 248, 248, 0.00) 99.28%);
    width: 100%;
    max-width: 500px;
    margin: 2rem ;
    overflow: auto;
    max-width: 40rem;
}

.ForgotPassword_formItem__ksY48 {
    margin-top: 1rem;
}

.ForgotPassword_formLabel__KkJaV {
    font-weight: 600;
}

.ForgotPassword_formText__rBJLY{
    background: #FFF;
    margin-top: 10px;
}

.ForgotPassword_validation__Gyc5A {
    color: red;
    font-size: 14px;
    margin-top: 8px;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/ForgotPassword.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;IACG,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,qDAAqD;IACrD,sGAAsG;IACtG,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;EACjB","sourcesContent":["/*\r\n * Copyright (c) 2024 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 22/2/2024\r\n */\r\n\r\n .container {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.paper {\r\n    padding: 2rem;\r\n    border-radius: 0.5rem;\r\n    box-shadow: 0px 4px 10px 0px rgba(89, 124, 215, 0.25);\r\n    background: linear-gradient(91deg, rgba(222, 248, 248, 0.32) 23.22%, rgba(222, 248, 248, 0.00) 99.28%);\r\n    width: 100%;\r\n    max-width: 500px;\r\n    margin: 2rem ;\r\n    overflow: auto;\r\n    max-width: 40rem;\r\n}\r\n\r\n.formItem {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.formLabel {\r\n    font-weight: 600;\r\n}\r\n\r\n.formText{\r\n    background: #FFF;\r\n    margin-top: 10px;\r\n}\r\n\r\n.validation {\r\n    color: red;\r\n    font-size: 14px;\r\n    margin-top: 8px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ForgotPassword_container__7KQGp`,
	"paper": `ForgotPassword_paper__xHjci`,
	"formItem": `ForgotPassword_formItem__ksY48`,
	"formLabel": `ForgotPassword_formLabel__KkJaV`,
	"formText": `ForgotPassword_formText__rBJLY`,
	"validation": `ForgotPassword_validation__Gyc5A`
};
export default ___CSS_LOADER_EXPORT___;
